module.exports = __webpack_public_path__ + "static/img/heat-treatmentB.4e94e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentB.png
// module id = 7vlT
// module chunks = 1